import { Card, Metric, SectionHeader } from '../../blocks';
import { Grid } from '@material-ui/core';
import { currencyFormatter } from '../../formatters';
import { css } from '@emotion/react';

const ClaimAdjustmentsCard = ({ claim }) => {
    const itemsTotal = (claim.items || []).reduce((acc, item) => {
        return acc + (item.amount || 0);
    }, 0);

    return (
        <Card>
            <Grid
                item
                css={css`
                    margin-bottom: 1rem;
                `}
            >
                <SectionHeader>Claim Total</SectionHeader>
            </Grid>
            <Grid item>
                <Metric label="Requested Amount for Item(s)" value={itemsTotal} formatter={currencyFormatter} />
            </Grid>
            <Grid item>
                <Metric label="Requested Freight Amount" value={claim.freight_amount} formatter={currencyFormatter} />
            </Grid>
            <hr />
            <Grid item>
                <Metric label="Total" value={claim.freight_amount + itemsTotal} formatter={currencyFormatter} />
            </Grid>
        </Card>
    );
};

export default ClaimAdjustmentsCard;
